import { X } from "lucide-react";

const CategoryEditor = ({
  categories,
  inputValue,
  onInputChange,
  onAdd,
  onRemove,
  accent = "#FFE800",
  accentBorder = "border-[#FFE800]/40",
  accentText = "text-[#FFE800]",
}) => (
  <div>
    <p className="text-xs text-gray-500 mb-2">Additional Categories</p>
    <div className="flex flex-wrap gap-2 mb-2">
      {categories.map((cat) => (
        <span key={cat} className={`flex items-center gap-1 border ${accentBorder} px-2 py-1 text-xs ${accentText}`}>
          {cat}
          <button onClick={() => onRemove(cat)} className="hover:text-red-400">
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
    </div>
    <div className="flex gap-2">
      <input
        value={inputValue}
        onChange={(e) => onInputChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onAdd();
          }
        }}
        className="flex-1 bg-black/50 border border-white/10 text-white font-data text-sm py-2 px-3"
        placeholder="Add category..."
      />
      <button
        onClick={onAdd}
        className={`border ${accentBorder} px-3 py-2 text-xs font-data ${accentText}`}
      >
        Add
      </button>
    </div>
  </div>
);

export default CategoryEditor;
